export default __webpack_public_path__ + "static/media/criar_conta_gestor.d9f6e560.png";